import React, { useEffect, useState } from "react";
import moment from "moment";
import "../IncomeDashboard.css";
import incomeIcon from "../../../assets/images/Contributions-income.png";
import passiveIncomeIcon from "../../../assets/images/easy.png";
import activeIncomeIcon from "../../../assets/images/lift_weight.png";
import NewLoader from "../../../components/styled-components/loader/NewLoader";
import getFAClientName from "../../../helpers/getFAClientName";
export const IncomeReport = ({ data, isLoading, monthlyDataReport, yearlyDataReport,incomeReport }) => {
  const [clientName, setClientName] = useState("");
  const incomeReportCards = [
    {
      id: 1,
      name: "Active Income",
      thisYear:
      incomeReport &&
      incomeReport.yearlyActiveIncome ?
        parseFloat(incomeReport.yearlyActiveIncome)
          .toFixed(2)
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",") :0,
      thisMonth:
      incomeReport &&
      incomeReport.monthlyActiveIncome ?
        parseFloat(incomeReport.monthlyActiveIncome)
          .toFixed(2)
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",") :0,
      icon: activeIncomeIcon,
      total: "123456",
    },
    {
      id: 2,
      name: "Passive Income",
      thisYear:
      incomeReport &&
      incomeReport.yearlyPassiveIncome ?
        parseFloat(incomeReport.yearlyPassiveIncome)
          .toFixed(2)
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",") :0,
      thisMonth:
      incomeReport &&
      incomeReport.monthlyPassiveIncome ?
        parseFloat(incomeReport.monthlyPassiveIncome)
          .toFixed(2)
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",") :0,
      icon: passiveIncomeIcon,
      total: "123456",
    },
  ];
  useEffect(()=>{
    const name = getFAClientName();
    if (name) setClientName(name);
  },[])

  return (
    <React.Fragment>
      <div className="incomeCard1">
        <h3 className="Reportheading">Income</h3>
        <div className="incomeRow">
          <div>
            <div className="budget-home-icon-container" style={{ gap: "4px" }}>
              <div
                className="asset-home-icon"
                style={{ textAlign: "center", width: "48%" }}
              >
                <img
                  style={{ width: "100%", minWidth: "100px" }}
                  src={incomeIcon}
                  alt="incomeIcon"
                />
              </div>
              <div style={{ textAlign: "center", width: "49%" }}>
                <div className="incomeCardConatiner">
                  <h3
                    className="Reportheading"
                    style={{
                      fontSize: "16px",
                      fontWeight: "900",
                    }}
                  >
                    Year to date
                  </h3>
                  <h3 className="Reportheading" style={{ fontWeight: "700" }}>
                    ${" "}
                    {incomeReport &&
                      incomeReport.totalYearly ?
                      incomeReport.totalYearly
                        .toFixed(2)
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",") :0}
                  </h3>
                </div>
                <div className="incomeCardConatiner">
                  <h3
                    className="Reportheading"
                    style={{
                      fontSize: "16px",
                      fontWeight: "900",
                    }}
                  >
                    This Month
                  </h3>
                  <h3 className="Reportheading" style={{ fontWeight: "700" }}>
                    ${" "}
                    {incomeReport &&
                      incomeReport.totalMonthly ?
                      incomeReport.totalMonthly
                        .toFixed(2)
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",") :0}
                  </h3>
                </div>
              </div>
            </div>
            {/*<h3 className="Reportheading">Synopsis: </h3>
            <p className="reportPara">
              Gross Income, Adjusted Gross Income, Modified Adjusted Gross
              Income, Passive or Earned
            </p> */}
          </div>
          <div>
            <div className="reportrow">
              <div className="reportrowData">
                <span className="reportTitle"> Client Name</span>
                <span className="reportsubTitle">
                {clientName || localStorage.getItem("User") || ""}
                </span>
              </div>
              <div className="reportrowData">
                <span className="reportTitle"> Today's Date </span>
                <span className="reportsubTitle">
                  {" "}
                  {moment().format("MM/DD/YYYY")}
                </span>
              </div>
            </div>
            {/*  <div className="reportrow2">
              <div className="reportrowData">
                <span className="reportTitle"> Spouse Name</span>
                <span className="reportsubTitle"> Tracy Jones</span>
              </div>
              <div className="reportrowData">
                <span className="reportTitle"> Today's Date </span>
                <span className="reportsubTitle">
                  {" "}
                  {moment().format("MM/DD/YYYY")}
                </span>
              </div>
            </div> */}
          </div>
        </div>
      </div>
      {incomeReportCards &&
        incomeReportCards.map((item, index) => (
          <div className="incomeCard2" key={index}>
            <div className="budget-home-icon-container" style={{ gap: "4px" }}>
              <h3 className="incomeReportMainHaeding">{item.name}</h3>

              <div
                className="asset-home-icon"
                style={{ textAlign: "center", width: "35%" }}
              >
                <img
                  style={{ width: "100%", minWidth: "100px" }}
                  src={item.icon}
                  alt="incomeIcon"
                />
              </div>
            </div>
            <div className="incomeRow">
              <div>
                <div className="IncomeRowMonth">
                  <span className="IncomeRowMonthHeading"> This Month</span>
                  <span className="IncomeRowMonthValue">${item.thisMonth}</span>
                </div>
                <div className="IncomeRowMonth" style={{ marginTop: "1rem" }}>
                  <span className="IncomeRowMonthHeading">Year to Date </span>
                  <span className="IncomeRowMonthValue"> ${item.thisYear}</span>
                </div>
              </div>
            </div>
          </div>
        ))}
      {/*Incomereport &&
        Incomereport.map((item, index) => (
          <div key={index} className="incomeCard2">
            <h3 className="incomeReportheading">{item.name}</h3>
            <div className="incomeRow">
              <div>
                <div className="reportrow1">
                  <div className="reportrowData">
                    <span className="incomereportTitle"> Passive Income</span>
                    <span className="incomereportsubTitle">
                      ${item.passiveIncome}
                    </span>
                  </div>
                  <div className="reportrowData">
                    <span className="incomereportTitle"> Earned Income </span>
                    <span className="incomereportsubTitle">
                      {" "}
                      ${item.earnedIncome}
                    </span>
                  </div>
                </div>
                <div className="incomereportrow2">
                  <div className="reportrowData1">
                    <span className="incomereportTitle">
                      {item.name === "Adjusted Gross Income"
                        ? "Total Adjusted Gross Income"
                        : " Total Gross Income"}
                    </span>
                    <span className="incomereportsubTitle"> ${item.total}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )) */}
    </React.Fragment>
  );
};
